export function NotoV1Owl(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 128 128" {...props}>
      <path
        fill="#885c52"
        d="M100.8 49.5c4.2-10.2.9-16-1-21.2c-1.7-4.6 3-6.9 3-6.9c-1.8 0-3.8-.8-3.8-.8c3.6-2.5 5.8-9.1 5.8-9.1c-2.5 2.3-5.9 2.4-5.9 2.4c5.6-5.4 3.9-12.9 3.9-12.9S97 8.8 86.2 13.5c-8.8 3.8-18.5 4.7-22.1 4.7c-3.6 0-13.3-.9-22.1-4.7C31.1 8.9 25.3 1 25.3 1s-1.8 7.5 3.9 12.9c0 0-3.4-.1-5.9-2.4c0 0 2.1 6.6 5.8 9.1c0 0-2 .8-3.8.8c0 0 4.7 2.3 3 6.9c-1.9 5.2-5.2 10.9-1 21.2c0 0-28.7 47.9 33.6 76.3c1 .5 2.1.7 3.2.7s2.2-.3 3.2-.7c62.2-28.4 33.5-76.3 33.5-76.3z"
      ></path>
      <circle cx="82.4" cy="41.6" r="14.7" fill="#bb917a"></circle>
      <circle cx="82.4" cy="41.6" r="11.3" fill="#fff"></circle>
      <circle cx="82.4" cy="41.6" r="6.5" fill="#2f2f2f"></circle>
      <circle cx="45.7" cy="41.6" r="14.7" fill="#bb917a"></circle>
      <circle cx="45.7" cy="41.6" r="11.3" fill="#fff"></circle>
      <circle cx="45.7" cy="41.6" r="6.5" fill="#2f2f2f"></circle>
      <path
        fill="#fef6e0"
        d="M38.4 81.7c0-13.6 7-21.7 25.6-21.7v55.8s-8.5-.5-14.9-7.6c-5-5.6-10.7-15.7-10.7-26.5z"
      ></path>
      <path
        fill="#fef6e0"
        d="M89.6 81.7c0-13.6-7-21.7-25.6-21.7v55.8s8.5-.5 14.9-7.6c5-5.6 10.7-15.7 10.7-26.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M37.1 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3c1.6 0 3 1.3 3 3v9.5c-.1 1.7-1.4 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M37.1 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c-.1-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M43.1 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3c1.6 0 3 1.3 3 3v9.5c0 1.7-1.4 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M43.1 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c0-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M49.3 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3s3 1.3 3 3v9.5c0 1.7-1.4 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M49.3 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c0-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M78.4 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3c1.6 0 3 1.3 3 3v9.5c0 1.7-1.4 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M78.4 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c0-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M84.4 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3s3 1.3 3 3v9.5c0 1.7-1.3 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M84.4 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c0-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M90.6 121c-1.6 0-3-1.3-3-3v-9.5c0-1.6 1.3-3 3-3c1.6 0 3 1.3 3 3v9.5c0 1.7-1.4 3-3 3z"
      ></path>
      <path
        fill="#885c52"
        d="M90.6 106c1.4 0 2.5 1.1 2.5 2.5v9.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-9.5c0-1.4 1.1-2.5 2.5-2.5m0-1c-1.9 0-3.5 1.6-3.5 3.5v9.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-9.5c0-1.9-1.6-3.5-3.5-3.5z"
      ></path>
      <path
        fill="#ffc148"
        d="M67.3 49.6c-1.7-2.1-4.8-2.1-6.5 0c-1.3 1.6-2.5 3.8-2.3 6.7c.2 4.2 2.6 7.2 4.2 8.7c.8.7 1.9.7 2.7 0c1.6-1.5 4-4.5 4.2-8.7c.1-3-1-5.2-2.3-6.7z"
      ></path>
      <ellipse cx="83.6" cy="39.3" fill="#fff" rx="2.2" ry="2.3"></ellipse>
      <ellipse cx="47.4" cy="39.3" fill="#fff" rx="2.2" ry="2.3"></ellipse>
      <path
        fill="none"
        stroke="#bb917a"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="3"
        d="M46.6 76.7c2.5 4.7 9.2 4.7 11.6 0m0 0c2.5 4.7 9.2 4.7 11.6 0m0 0c2.5 4.7 9.2 4.7 11.6 0m-29 15.9c2.5 4.7 9.2 4.7 11.6 0m0 0c2.5 4.7 9.2 4.7 11.6 0"
      ></path>
    </svg>
  );
}
export function NotoChicken(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 128 128" {...props}>
      <path
        fill="#B1B1B1"
        d="M113.97 96.23L37.1 98.91s-3 13.81-2.25 16.05c.28.84 9.85-8.45 9.85-8.45s11.97 14.78 12.81 14.64c.84-.14 10-9.43 10-9.43s13.66 11.4 14.64 11.4s9.29-12.11 9.29-12.11s10.56 7.6 11.26 7.46c.7-.14 7.88-11.54 7.88-11.54s11.22 3.33 12.34 3.05c1.14-.28-5.01-12.2-8.95-13.75z"
      ></path>
      <path
        fill="#E0E0E0"
        d="m33.16 54.98l-.66-17.69l11.97-11.54l26.56.38s7.04 6.34 8.87 7.46c1.83 1.13 8.24 4.38 19.83 18.59c6.17 7.57 11.15 20.26 12.55 23.64s10.84 33.08 10.84 33.93s-11.54-9.43-12.25-8.87c-.7.56-7.46 13.51-8.31 13.8c-.84.28-10.28-9.15-11.26-8.73s-8.73 13.8-9.29 13.8s-12.1-14.37-13.51-14.65c-1.41-.28-10 11.68-11.12 11.68c-1.13 0-11.4-16.61-12.67-16.61s-9.2 13.05-9.9 13.61s-2.21-20.51-2.49-23.04s.84-35.76.84-35.76z"
      ></path>
      <path
        fill="#FFF"
        d="M59.44 83.06c-1.07 0-2.06-.69-2.39-1.77l-1.78-5.82a2.5 2.5 0 0 1 4.78-1.46l1.78 5.82a2.5 2.5 0 0 1-2.39 3.23zm20.37 6.57c-.98 0-1.91-.58-2.31-1.54l-2.82-6.76c-.53-1.28.07-2.74 1.35-3.27c1.28-.53 2.74.07 3.27 1.35l2.82 6.76a2.497 2.497 0 0 1-2.31 3.46zm13.51-8.45a2.5 2.5 0 0 1-2.26-1.43l-2.53-5.35a2.499 2.499 0 0 1 1.19-3.33c1.25-.59 2.74-.06 3.33 1.19l2.53 5.35a2.499 2.499 0 0 1-2.26 3.57zM77.18 63.91c-.79 0-1.57-.38-2.06-1.08l-4.6-6.66c-.78-1.14-.5-2.69.64-3.48c1.14-.79 2.69-.5 3.48.64l4.6 6.66c.78 1.14.5 2.69-.64 3.48c-.43.3-.93.44-1.42.44z"
      ></path>
      <path
        fill="#FF615E"
        d="M44.43 69.48c3 .23 29.14-4.04 19.8-24.68c-7.22-15.97-27.5-1.97-31.25 3.57c-.68 1.01-1.92 16.89-1.92 16.89S22.04 78.21 25 85.39s11.74 8.54 17.03 2.39c4.37-5.06 2.82-15.9 2.4-18.3z"
      ></path>
      <path
        fill="#FF615E"
        d="M35.13 38.23c2.08-3.22 8.87-10 19.57-10.42c10.7-.42 16.19 1.69 18.16 2.53c1.97.84 7.6 3.66 7.6 3.66s10.58-5 10.16-15.98s-11.7-11.75-16.07-9.35s-5.07 5.91-8.31 6.05c-3.24.14-5.77-7.74-15.91-3.8c-8.63 3.36-5.85 11.63-9.01 13.66c-3.52 2.25-11.12-2.53-16.47 4.93s1.27 14.22 2.67 15.35c1.41 1.13 6.05 3.71 6.05 3.71s-1.53-5.55 1.56-10.34z"
      ></path>
      <path
        fill="#FBBB02"
        d="M41.42 65.07c1.3-.69.28-6.29-2.91-10.7s-5.63-6.29-5.63-6.29s-11.54 2.63-18.96 6.76c-4.14 2.31-9.24 7.37-8.68 9.24c.56 1.88 11.19 1.39 20.13 1.13c9.48-.28 14.46.71 16.05-.14z"
      ></path>
      <path
        fill="#FE5F12"
        d="M5.19 63.34s10.75-.75 15.58-1.41c4.83-.66 7.96-1.11 9.81-1.55c1.97-.47 6.19-1.69 6.19-1.69l.28 1.97s-10.23 2.3-16.14 2.82c-5.2.45-13.7 1.08-14.41 1.08s-1.13-.33-1.31-.56s0-.66 0-.66z"
      ></path>
      <ellipse
        cx="37.83"
        cy="59.51"
        fill="#FE5F12"
        rx="1.62"
        ry="1.67"
      ></ellipse>
      <path
        fill="#2C2B2C"
        d="M56.15 54.6c-.76 3.42-3.84 5.78-7.78 4.37c-2.93-1.05-4.01-4.6-2.9-7.92s4.29-4.85 7.34-4.23c3.07.61 4.1 4.36 3.34 7.78z"
      ></path>
    </svg>
  );
}
export function IcOutlineFavoriteBorder(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1l-.1-.1C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5c0 2.89-3.14 5.74-7.9 10.05z"
      ></path>
    </svg>
  );
}
export function IcOutlineLogin(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5l-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
      ></path>
    </svg>
  );
}
export function Fa6SolidBars(props) {
  return (
    <svg width="0.88em" height="1em" viewBox="0 0 448 512" {...props}>
      <path
        fill="currentColor"
        d="M0 96c0-17.67 14.33-32 32-32h384c17.7 0 32 14.33 32 32c0 17.7-14.3 32-32 32H32c-17.67 0-32-14.3-32-32zm0 160c0-17.7 14.33-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.67 0-32-14.3-32-32zm416 192H32c-17.67 0-32-14.3-32-32s14.33-32 32-32h384c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
      ></path>
    </svg>
  );
}
export function MdiCardsHeartOutline(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m12.1 18.55l-.1.1l-.11-.1C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5c1.54 0 3.04 1 3.57 2.36h1.86C13.46 6 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5c0 2.89-3.14 5.74-7.9 10.05M16.5 3c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3Z"
      ></path>
    </svg>
  );
}
export function MdiCardsHeart(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53L12 21.35Z"
      ></path>
    </svg>
  );
}
export function MdiTrashCanOutline(props) {
  return (
    <svg width="2rem" height="2rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M9 3v1H4v2h1v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h1V4h-5V3H9M7 6h10v13H7V6m2 2v9h2V8H9m4 0v9h2V8h-2Z"
      ></path>
    </svg>
  );
}
export function MdiFilterOutline(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M15 19.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0L9.29 16.7a.989.989 0 0 1-.29-.83v-5.12L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L15 10.75v9.13M7.04 5L11 10.06v5.52l2 2v-7.53L16.96 5H7.04Z"
      ></path>
    </svg>
  );
}
export function UiwStarOn(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        d="m9.89 17.514l-4.21 2.257l-.099.044c-.715.27-1.39.216-1.903-.242c-.482-.43-.657-1.046-.557-1.755l.704-4.86l-3.18-3.342c-.55-.56-.765-1.248-.58-1.968c.205-.799.88-1.258 1.851-1.412l4.227-.638l2.213-4.585C8.7.366 9.236-.017 9.911.001c.66.017 1.183.422 1.593 1.143l2.14 4.486l4.74.658c.753.13 1.308.522 1.53 1.176c.22.653.01 1.313-.557 1.987l-3.44 3.51l.772 4.856c.122.84-.025 1.505-.586 1.9c-.506.357-1.139.357-1.867.107l-.12-.053l-4.226-2.257Z"
      ></path>
    </svg>
  );
}
export function MdiAccountPlusOutline(props) {
  return (
    <svg width="2rem" height="2rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M15 4a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4m0 1.9a2.1 2.1 0 1 1 0 4.2A2.1 2.1 0 0 1 12.9 8A2.1 2.1 0 0 1 15 5.9M4 7v3H1v2h3v3h2v-3h3v-2H6V7H4m11 6c-2.67 0-8 1.33-8 4v3h16v-3c0-2.67-5.33-4-8-4m0 1.9c2.97 0 6.1 1.46 6.1 2.1v1.1H8.9V17c0-.64 3.1-2.1 6.1-2.1Z"
      ></path>
    </svg>
  );
}
export function MdiAccountCheckOutline(props) {
  return (
    <svg width="2rem" height="2rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m21.1 12.5l1.4 1.41l-6.53 6.59L12.5 17l1.4-1.41l2.07 2.08l5.13-5.17M11 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c.68 0 1.5.09 2.41.26l-1.67 1.67l-.74-.03c-2.97 0-6.1 1.46-6.1 2.1v1.1h6.2L13 20H3v-3c0-2.66 5.33-4 8-4Z"
      ></path>
    </svg>
  );
}
export function IconParkOutlineEmailFail(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 48 48"
      style={{ color: "red" }}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="M44 24V9H4v30h20m16-8l-8 8m0-8l8 8"></path>
        <path d="m4 9l20 15L44 9"></path>
      </g>
    </svg>
  );
}
export function IconParkOutlineEmailSuccessfully(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 48 48"
      style={{ color: "green" }}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="M44 24V9H4v30h20m7-3l5 4l8-10"></path>
        <path d="m4 9l20 15L44 9"></path>
      </g>
    </svg>
  );
}
export function IconoirPasswordError(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      style={{ color: "red" }}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m15.121 20.364l2.122-2.121m0 0l2.121-2.122m-2.121 2.122L15.12 16.12m2.122 2.122l2.121 2.121M21 13V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6m1-4.99l.01-.011m3.99.011l.01-.011M8 11.01l.01-.011"
      ></path>
    </svg>
  );
}
export function IconoirPasswordPass(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      style={{ color: "green" }}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21 13V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h7m2.5 2.5l2 2l4-4M12 11.01l.01-.011m3.99.011l.01-.011M8 11.01l.01-.011"
      ></path>
    </svg>
  );
}
export function LucideUserX(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      style={{ color: "red" }}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <path d="m18 8l5 5m0-5l-5 5"></path>
      </g>
    </svg>
  );
}
export function LucideUserCheck(props) {
  return (
    <svg
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 24 24"
      style={{ color: "green" }}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <path d="m17 11l2 2l4-4"></path>
      </g>
    </svg>
  );
}
export function AntDesignLoading3QuartersOutlined(props) {
  return (
    <svg width="5rem" height="5rem" viewBox="0 0 1024 1024" {...props}>
      <path
        fill="currentColor"
        d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3c22.2 52.4 53.9 99.5 94.3 139.9c40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6c52.4-22.2 99.5-53.9 139.9-94.3c40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9a437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7c26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7c-63.1 26.8-130.2 40.3-199.3 40.3z"
      ></path>
    </svg>
  );
}
export function RiUser3Line(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M20 22h-2v-2a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v2H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v2zm-8-9a6 6 0 1 1 0-12a6 6 0 0 1 0 12zm0-2a4 4 0 1 0 0-8a4 4 0 0 0 0 8z"
      ></path>
    </svg>
  );
}
export function IcOutlineLogout(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4l-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"
      ></path>
    </svg>
  );
}
export function CarbonHome(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M16.612 2.214a1.01 1.01 0 0 0-1.242 0L1 13.419l1.243 1.572L4 13.621V26a2.004 2.004 0 0 0 2 2h20a2.004 2.004 0 0 0 2-2V13.63L29.757 15L31 13.428ZM18 26h-4v-8h4Zm2 0v-8a2.002 2.002 0 0 0-2-2h-4a2.002 2.002 0 0 0-2 2v8H6V12.062l10-7.79l10 7.8V26Z"
      ></path>
    </svg>
  );
}
export function CarbonExplore(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M22.707 9.293a1 1 0 0 0-1.023-.242l-9 3a1.001 1.001 0 0 0-.633.633l-3 9a1 1 0 0 0 1.265 1.265l9-3a1.001 1.001 0 0 0 .633-.633l3-9a1 1 0 0 0-.242-1.023ZM11.581 20.42l2.21-6.628l4.419 4.419Z"
      ></path>
      <path
        fill="currentColor"
        d="M16 30a14 14 0 1 1 14-14a14.016 14.016 0 0 1-14 14Zm0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4Z"
      ></path>
    </svg>
  );
}
export function CarbonPlaylist(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M4 6h18v2H4zm0 6h18v2H4zm0 6h12v2H4zm17 0l7 5l-7 5V18z"
      ></path>
    </svg>
  );
}
export function CarbonTime(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        d="M16 30a14 14 0 1 1 14-14a14 14 0 0 1-14 14Zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4Z"
      ></path>
      <path
        fill="currentColor"
        d="M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z"
      ></path>
    </svg>
  );
}
export function CodiconHistory(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.507 12.324a7 7 0 0 0 .065-8.56A7 7 0 0 0 2 4.393V2H1v3.5l.5.5H5V5H2.811a6.008 6.008 0 1 1-.135 5.77l-.887.462a7 7 0 0 0 11.718 1.092zm-3.361-.97l.708-.707L8 7.792V4H7v4l.146.354l3 3z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
export function UiwLikeO(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        d="M1.36 9.495v7.157h3.03l.153.018c2.813.656 4.677 1.129 5.606 1.422c1.234.389 1.694.484 2.531.54c.626.043 1.337-.198 1.661-.528c.179-.182.313-.556.366-1.136a.681.681 0 0 1 .406-.563c.249-.108.456-.284.629-.54c.16-.234.264-.67.283-1.301a.682.682 0 0 1 .339-.57c.582-.337.87-.717.93-1.163c.066-.493-.094-1.048-.513-1.68a.683.683 0 0 1 .176-.936c.401-.282.621-.674.676-1.23c.088-.886-.477-1.541-1.756-1.672a9.42 9.42 0 0 0-3.394.283a.68.68 0 0 1-.786-.95c.5-1.058.778-1.931.843-2.607c.085-.897-.122-1.547-.606-2.083c-.367-.406-.954-.638-1.174-.59c-.29.062-.479.23-.725.818c-.145.348-.215.644-.335 1.335c-.115.656-.178.952-.309 1.34c-.395 1.176-1.364 2.395-2.665 3.236a11.877 11.877 0 0 1-2.937 1.37a.676.676 0 0 1-.2.03H1.36Zm-.042 8.52c-.323.009-.613-.063-.856-.233c-.31-.217-.456-.559-.459-.953l.003-7.323c-.034-.39.081-.748.353-1.014c.255-.25.588-.368.94-.36h2.185A10.505 10.505 0 0 0 5.99 6.95c1.048-.678 1.82-1.65 2.115-2.526c.101-.302.155-.552.257-1.14c.138-.789.224-1.156.422-1.628c.41-.982.948-1.462 1.69-1.623c.73-.158 1.793.263 2.465 1.007c.745.824 1.074 1.855.952 3.129c-.052.548-.204 1.161-.454 1.844a10.509 10.509 0 0 1 2.578-.056c2.007.205 3.134 1.512 2.97 3.164c-.072.712-.33 1.317-.769 1.792c.369.711.516 1.414.424 2.1c-.106.79-.546 1.448-1.278 1.959c-.057.693-.216 1.246-.498 1.66a2.87 2.87 0 0 1-.851.834c-.108.684-.335 1.219-.706 1.595c-.615.626-1.714.999-2.718.931c-.953-.064-1.517-.18-2.847-.6c-.877-.277-2.693-.737-5.43-1.377H1.317Zm1.701-8.831a.68.68 0 0 1 .68-.682a.68.68 0 0 1 .678.682v7.678a.68.68 0 0 1-.679.681a.68.68 0 0 1-.679-.681V9.184Z"
      ></path>
    </svg>
  );
}
export function AntDesignLikeOutlined(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 1024 1024" {...props}>
      <path
        fill="currentColor"
        d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7c0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4c47.6-20.3 78.3-66.8 78.3-118.4c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19l13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19l13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19l13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7c9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
      ></path>
    </svg>
  );
}
export function TablerPlay(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        d="M5 5v14a2 2 0 0 0 2.75 1.84L20 13.74a2 2 0 0 0 0-3.5L7.75 3.14A2 2 0 0 0 5 4.89"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}
export function IcRoundPlaylistAdd(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm5 8v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z"
      ></path>
    </svg>
  );
}
export function IcRoundPlaylistRemove(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M13.71 21.3c.39.39 1.02.39 1.41 0L17 19.41l1.89 1.89a.996.996 0 1 0 1.41-1.41L18.41 18l1.89-1.89a.996.996 0 1 0-1.41-1.41L17 16.59l-1.89-1.89a.996.996 0 1 0-1.41 1.41L15.59 18l-1.89 1.89c-.38.38-.38 1.02.01 1.41zM14 11c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1zm0-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1zM3 15c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
      ></path>
    </svg>
  );
}
export function IcOutlineClose(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"
      ></path>
    </svg>
  );
}
export function MdiTextBoxRemoveOutline(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m14.46 15.88l1.42-1.42L18 16.59l2.12-2.13l1.42 1.42L19.41 18l2.13 2.12l-1.42 1.42L18 19.41l-2.12 2.13l-1.42-1.42L16.59 18l-2.13-2.12M5 3h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2m2 4h10v2H7V7m0 4h10v1.08c-.85.14-1.63.46-2.32.92H7v-2m0 4h5v2H7v-2Z"
      ></path>
    </svg>
  );
}
export function MdiTextBoxCheckOutline(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="m17 21l-2.75-3l1.16-1.16L17 18.43l3.59-3.59l1.16 1.41M12.8 21H5c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2h14c1.11 0 2 .89 2 2v7.8c-.61-.35-1.28-.6-2-.72V5H5v14h7.08c.12.72.37 1.39.72 2m-.8-4H7v-2h5m2.68-2H7v-2h10v1.08c-.85.14-1.63.46-2.32.92M17 9H7V7h10"
      ></path>
    </svg>
  );
}
export function IcRoundPlayArrow(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69L9.54 5.98A.998.998 0 0 0 8 6.82z"
      ></path>
    </svg>
  );
}
export function IcRoundPause(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2zm6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2z"
      ></path>
    </svg>
  );
}
export function IcRoundStop(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z"
      ></path>
    </svg>
  );
}
export function IcRoundVolumeUp(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z"
      ></path>
    </svg>
  );
}
export function IcRoundVolumeDown(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M18.5 12A4.5 4.5 0 0 0 16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L9 9H6c-.55 0-1 .45-1 1z"
      ></path>
    </svg>
  );
}
export function IcRoundVolumeOff(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3.63 3.63a.996.996 0 0 0 0 1.41L7.29 8.7L7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91c-.36.15-.58.53-.58.92c0 .72.73 1.18 1.39.91c.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 1 0 1.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87c0-3.83-2.4-7.11-5.78-8.4c-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0 0 14 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
      ></path>
    </svg>
  );
}
export function IcOutlineRemoveRedEye(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5z"
      ></path>
    </svg>
  );
}
export function IcSharpTimer(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0 0 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7z"
      ></path>
    </svg>
  );
}
export function IcRoundSearch(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0c.41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
      ></path>
    </svg>
  );
}
export function IcRoundClose(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
      ></path>
    </svg>
  );
}
export function IcRoundDateRange(props) {
  return (
    <svg width="1rem" height="1rem" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9h14v10zM7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
      ></path>
    </svg>
  );
}
